import { handleSessionExpired } from '@/utils/session-navigation'
import { resolveErrorMessage } from '@/utils/request-policy'

export function createAuthExpiredHandler({ store, router, MessageBox }) {
  return context => handleSessionExpired({
    store,
    router,
    route: router && router.currentRoute,
    showConfirm: () => MessageBox.confirm(
      'The login status has expired. You can stay on this page or log in again',
      'System prompt',
      {
        confirmButtonText: 'Login again',
        cancelButtonText: 'cancel',
        type: 'warning'
      }
    ),
    context
  })
}

export function showBusinessError({ Notification }, payload) {
  Notification.error({
    title: payload.error || 'Request failed'
  })
}

export function showTransportError({ Message }, error) {
  Message({
    message: resolveErrorMessage(error),
    type: 'error',
    duration: 5 * 1000
  })
}
